import {Layout,Input, message,Button,Row,Col,Popconfirm, Breadcrumb, ConfigProvider, Pagination, Table, Modal, Tooltip } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import OAMSider from '../oam-sider';
import {SearchOutlined, ArrowUpOutlined, ArrowDownOutlined, } from '@ant-design/icons';
import GlobalCss from '@/global.module.less'
import { BACKEND_API_URL } from '@/constants/constants'
import React, { useEffect, useRef, useState } from "react";
import { sendHttpPostRequest } from '../../../api/http-request';
import Cookies from 'js-cookie';
import myStyles from './oam-report.module.less';
import Draggable  from "react-draggable";
import idataCodingTableStyles from "../../common/global-styles/idatacoding.module.less";



import {
    DragDropContext,
    Droppable,
    Draggable as DndDraggable
  } from 'react-beautiful-dnd';
import MenuOutlined from '@ant-design/icons/lib/icons/MenuOutlined';
import zhCN from 'antd/lib/locale/zh_CN';
import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you
import {CloseCircleOutlined} from '@ant-design/icons';

const { TextArea } = Input;

export interface Props {}
export interface Props2 {}

export const OAMReportEdit: React.FC<Props> = (props) => {
    const reportId = parseInt(window.location.search.split("=")[1]);  // 报告的ID
    const [report, setReport] = useState(null as any);  // 报告模板对象
    const [name, setName] = useState(null as any);  // 节点名称
    const [description, setDescription] = useState(null as any);  // 节点描述文本
    const [json, setJson] = useState([] as any);  // 报告的大纲

    const selectedNodes = useRef(null as any);//记录当前选择的报告节点


    const [nodeListResult, setNodeListResult] = useState([] as any[]);  // 当前显示的搜索
    const [nodeResultSum, setNodeResultSum] = useState(0);  // 搜索返回的结果数
    const [totalNodeCount, setTotalNodeCount] = useState(0);  // 搜索返回的总结果数
    const queryNodeContent = useRef('');  // 记录搜索串
    const nodeOrder = useRef('');  // 排序升序降序
    const nodeOrderBy = useRef('');  // 排序列
    const nodePage = useRef(1);  // 记录当前的页数
    const nodePageSize = useRef(10);  // 记录当前每页展示数量


    // 选择题默认选项
    const [isAddNodeModalVisible, setIsAddNodeModalVisible] = useState(false)

    const currentChapterInd = useRef(null as any);//当前处理的章索引

    const draggleRef = useRef<HTMLDivElement | null>(null)
  
    const [bounds,setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
    const [disabled,setDisabled] = useState(true)
  
    const onStart = (event:any, uiData:any) => {
      const { clientWidth, clientHeight } = window?.document?.documentElement;
      const targetRect= draggleRef?.current?.getBoundingClientRect();
      if(targetRect){
        setBounds( {
          left: -targetRect?.left + uiData?.x,
          right: clientWidth - (targetRect?.right - uiData?.x),
          top: -targetRect?.top + uiData?.y,
          bottom: clientHeight - (targetRect?.bottom - uiData?.y),
        }
      )
      }
    }
  
    useEffect(()=> {
        queryReportInfo();
        queryNodeList();
    },[])


    /** 选择了节点*/
    const rowNodeSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
        selectedNodes.current = selectedRows;
       
        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record: any) => ({
        disabled: checkContainsNodeInMenu(record.id) > 0
    }),
    };
         
    // 查询任务详情
    const queryReportInfo = () => {
        sendHttpPostRequest(
            'report/api/oam_query_report_by_id/',
            {report_id: reportId, sessionid: Cookies.get("sessionid")},
            (response) => {
                message.destroy();
                if (response.code == -100) {
                    // 未登录
                    window.location.href = '/oam_login?next=oam_report_node';
                } else if (response.is_ok == true) {
                    // 成功
                    setReport(response.query_info);
                    setName(response.query_info?.name);
                    setDescription(response.query_info?.description);
                    setJson(response.query_info?.json);
                
                } else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_report_node';
                } else {
                    message.error(response.message);
                }
            }
        )
    }


       /**
     * 查询报告节点列表
     */
        const queryNodeList = () => {
            sendHttpPostRequest(
                'report/api/oam_query_node_list/',
                {
                    sessionid: Cookies.get("sessionid"),
                    sid: Cookies.get("sessionid"),
                    query: queryNodeContent.current,
                    page: nodePage.current,
                    pagesize: nodePageSize.current,  
                    order: nodeOrder.current,
                    order_by: nodeOrderBy.current,
                    
                },
                (response: any) => {
                    message.destroy();
                    if (response.code == -100) {
                        // 未登录
                        window.location.href = '/oam_login?next=oam_report';
                    } else if (response.is_ok == true) {
                        // 成功
                        setNodeListResult(response.query_list);
                        setNodeResultSum(response.total_sum);
                        setTotalNodeCount(response.total_count);
                        
                    } else if (response.code == -501) {
                        // 权限不足
                        window.location.href = '/oam_login?next=oam_report';
                    } else {
                        message.error(response.message);
                    }
                }
            )
        }
    
        //点击了搜索按钮
        const onSearchTaskBtn = (e: any) => {
            nodePage.current = 1;
            queryNodeContent.current = e.target.value;
            queryNodeList();
        }
    
        // 表格发生变化
        const onNodeTableChange:any = (pagination:any, filters:any, sorter:any, extra: { currentDataSource: [], action: any })=> {
            if (sorter.order) { //如果选择了排序列
                nodeOrder.current = sorter.order;
                nodeOrderBy.current = sorter.field;
            }
            nodePage.current = 1;
            queryNodeList();
        }

    //页码和页数发生了变化
    const onNodePageChange = (newPage: number, newPageSize?: number | undefined) => {
        nodePage.current = newPage ? newPage : 1;
        if (newPageSize) {
            nodePageSize.current = newPageSize;
        }
        queryNodeList();
    }



    
       // 渲染操作
       const renderActions = (text:any, record:any) => {
        
            return <Row justify="start" align="middle" gutter={[8, 4]} >
                    <Col span={24}>
                    <Button style={{borderRadius:20,fontSize:14, margin:0, width:60}} 
                    size='small' id="lookover" value={record.id} type="default" onClick={onLookOverTaskBtnClick.bind(this, record.id)} > 查 看 </Button></Col>
                </Row>
            
        
    }
    const node_columns:any = [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          align: 'left',
          width: 70,
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
          ellipsis: true,
          align: 'left',
          width: 180,
        },
        {
            title: '创建者',
            dataIndex: 'creator_name',
            key: 'creator_name',
            width: 150,
            align: 'left',
            render: (t, r, i) => {
              return (
                <Row align="middle" justify="start" style={{ gap: '5px' }}>
                  <Col>
                    <img
                      className={GlobalCss.avatar}
                      src={BACKEND_API_URL + r.creator_avatar}
                      alt=""
                    />
                  </Col>
                  <Col>{r.creator_name}</Col>
                </Row>
              )
            },
          },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          align: 'center',
          width: 180,
          sorter: true,
          ellipsis: true,
          sortDirections: ['descend', 'ascend'],
          defaultSortOrder: 'descend',
        },
        {
          title: "操作",
          dataIndex: "actions",
          key: "actions",
          width: 80,
          ellipsis: false,
          align: 'center',
          render: renderActions ,
      },
    ];

    // 点了查看 报告节点 按钮
    const onLookOverTaskBtnClick = (id:any, event: any) => {
        window.open(`/oam_report_node_edit?node_id=${id}`);
    }
    
    // 保存报告模板
    const saveReport = () => {
        message.destroy();

        if(name.trim() == ''){
            message.error("报告名称不能为空~");
            return ''
        }

        if(description.trim() == ''){
            message.error("报告说明不能为空~");
            return ''
        }

        const requestParams = {
            sessionid: Cookies.get("sessionid"),
            sid: Cookies.get("sessionid"),
            report_id: report?.id,
            name: name,
            description: description,
            json: JSON.stringify(json),
        }

        sendHttpPostRequest(
            'report/api/oam_update_report/',
            requestParams,
            (response: any) => {
                if (response.code == -100) {
                    // 未登录
                    window.location.href = '/oam_login?next=oam_report';
                } else if (response.is_ok == true) {
                    // 成功
                    message.success("报告模板保存成功~");
                } else if (response.code == -501) {
                    // 权限不足
                    window.location.href = '/oam_login?next=oam_report';
                } else {
                    message.error(response.message);
                }
            }
        )
    }


     const handleAddChapterOk = () => { //添加章
        const newChapters = [...json];
        const newID = Date.parse(new Date().toString());
        newChapters.push({id: newID ,name: "新建章",tasks:[]});
        setJson(
            newChapters
        );
        saveReport();

     
     }
 
     const handleAddNodeOk = () => { //添加节点
        setIsAddNodeModalVisible(false);
        const newChapters = [...json];
        selectedNodes.current.map(row=>{
            newChapters[currentChapterInd.current].tasks.push(row);
        })
        
        setJson(
            newChapters.filter(group => group.tasks.length >= 0 )
        ); 

        saveReport();
        
    }



    const reorder = (list:any, startIndex:number, endIndex:number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    /**
     * Moves an item from one list to another list.
     */
    const move = (source, destination, droppableSource, droppableDestination) => {
        const sourceClone = Array.from(source);
        const destClone = Array.from(destination);
        const [removed] = sourceClone.splice(droppableSource.index, 1);

        destClone.splice(droppableDestination.index, 0, removed);

        const result = {};
        result[droppableSource.droppableId] = sourceClone;
        result[droppableDestination.droppableId] = destClone;

        return result;
    };
    const grid = 4;

    const getItemStyle = (isDragging, draggableStyle) => ({
            userSelect: "none",
            borderRadius:0,
            background: isDragging ? "#eef2ff":'white',
            ...draggableStyle
        });
        const getListStyle = isDraggingOver => ({
            borderRadius:5,
            margin:'auto',
            marginBottom:10,

    });


    function onDragEnd(result) {
        const { source, destination } = result;
    
        // dropped outside the list
        if (!destination) {
          return;
        }
        const sInd = +source.droppableId;
        const dInd = +destination.droppableId;
    
        if (sInd === dInd) {//节点在同一个章节内排序
          const items = reorder(json[sInd].tasks, source.index, destination.index) as any[];
          const newState = [...json];
          newState[sInd].tasks = items
          setJson(newState);
        } else {//节点在不同章节内移动排序
          const result = move(json[sInd].tasks, json[dInd].tasks, source, destination);
          const newState = [...json];
          newState[sInd].tasks = result[sInd];
          newState[dInd].tasks = result[dInd];
          setJson(newState);
          
        }
      }
    /**  */
    const handleAddNodeCancel = () => {
       setIsAddNodeModalVisible(false)
    }
 
    
    /** 检查当前大纲中是否包含某一个节点 */
    const checkContainsNodeInMenu = (nodeId: number | string) => {
        let result = 0;
        json?.map((chapter)=>{
            result = result + chapter?.tasks?.filter((item)=>(item.id == nodeId)).length;
        })
        return result;
    }

    /** 修改了某一章名称 */
    const onChapterNameChange = (chapterId, chapterInd, event:any)=>{
        if (event.target.value.trim() == ''){
            message.error("章节名不能为空！")
        }
        json[chapterInd].name = event.target.value; 
        const newChapters = [...json];
        setJson(JSON.parse(JSON.stringify(newChapters)));
        
    }
        
    return (
        <Layout style={{ minHeight: '100vh' }}>
            <OAMSider keys={['101']} openKeys={["sub-report"]}  />
                

            <Content style={{ backgroundColor:'#fff',borderRadius:5,minWidth:500,margin:50 ,paddingTop:20}}>
                <Breadcrumb style={{marginLeft:0,float:'left',marginTop: -50}}>
                    <Breadcrumb.Item>
                    <a href="/oam_report">报告列表</a>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                    <span style={{fontWeight: 500}}> 报告编辑 </span> 
                    </Breadcrumb.Item>
                </Breadcrumb>

                <div className={"css.search1"}  style={{paddingTop:20,paddingLeft:50,paddingRight:50,position:'relative'}}>
  
                <Row gutter={[8,8]} justify='start'  align='middle' style={{marginTop:-10,marginBottom:10}} >

                        <Col style={{marginTop:-10,textAlign:'right'}} span={24}>
                            {/*<Button type="default" style={{width:80,borderRadius:20,marginRight:10}} onClick={onLookOverBtnClick}>预览</Button> */}
                            <Button type="primary" style={{width:80,borderRadius:20}} onClick={saveReport}>保存</Button>
                        </Col>
                    </Row>  

            <div style={{padding:20,borderRadius:6}}>
                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:20}} >
                        <Col flex="100px" style={{color:"#00000073",textAlign:'left'}}>名称</Col>
                        <Col flex="auto" style={{textAlign:'left'}}>
                            <Input placeholder="请输入报告模板名称" value={name} onChange={(e)=>{setName(e.target.value)}} style={{maxWidth:400,borderRadius:3,width:"100%"}}/>
                        </Col>
                        <Col flex="200px">
                        </Col>
                    </Row>

                    <Row gutter={[8,8]} justify='start'  align='top' style={{marginBottom:10}} >
                        <Col flex="100px" style={{color:"#00000073",textAlign:'left'}}>说明</Col>
                        <Col flex="auto" style={{textAlign:'left'}}>
                            <TextArea placeholder="请输入报告模板说明" 
                            style={{borderRadius:3,width:"100%"}} 
                            autoSize={{minRows: 4, maxRows:16}} 
                            value={description} 
                            onChange={(e)=>{setDescription(e.target.value)}}/>
 
                        </Col>
                    </Row>


                    <Row gutter={[8,8]} justify='start'  align='middle' style={{marginBottom:10}}>
                        <Col flex="100px" style={{color:"#00000073",textAlign:'left'}}>报告大纲</Col>
                        <Col flex="100px" style={{textAlign:'left'}}>
                           
                        </Col>
                        <Col flex="100px">
                            
                        </Col>
                    </Row>


                    <DragDropContext  onDragEnd={onDragEnd}> {/*拖拽上下文 */}
                    {json?.map((chapter, chapterInd) => (
                        <Droppable key={chapterInd} droppableId={`${chapterInd}`}> 
                        {(provided, snapshot) => (
                            <div
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                            {...provided.droppableProps}
                            >  
                                <Row gutter={[0, 4]} justify='start' align='middle' className={myStyles.chapterHeader}>
                                    <Col flex='80px' style={{fontWeight:500,paddingLeft:10}}>  { "第" +  (chapterInd + 1) + "章" }</Col>
                                    <Col flex='auto' style={{textAlign:"left", overflow: "hidden"}}> <Input onChange={onChapterNameChange.bind(this,chapter.id, chapterInd)} style={{width:200}} value={chapter.name}></Input> </Col>
                                    
                                    <Col flex='250px' style={{textAlign:"right",marginRight:6}}> 
    
                                        <Button  onClick={()=>{currentChapterInd.current =  chapterInd;setIsAddNodeModalVisible(true)}} size="small" style={{marginRight:10, borderRadius:3}} type={'primary'}> + 节点</Button>

                                        <Tooltip title="上移一章">  <ArrowUpOutlined style={{cursor:'pointer'}}
                                            onClick={() => {

                                                const newChapters = [...json];

                                                if(chapterInd!=0){
                                                    newChapters[chapterInd] = newChapters.splice(chapterInd-1, 1, newChapters[chapterInd])[0];
                                                    setJson(JSON.parse(JSON.stringify(newChapters)));
                                                }else{
                                                    //newChapters.push(newChapters.shift());
                                                    message.info("已经是第一章了，无法上移")
                                                }
                                        
                                                
                                                
                                            }}/>  </Tooltip>

                                        <Tooltip title="下移一章"> <ArrowDownOutlined style={{cursor:'pointer'}} 
                                            onClick={() => {
                                                const newChapters = [...json];
                                                if(chapterInd!=newChapters.length-1){
                                                    newChapters[chapterInd] = newChapters.splice(chapterInd+1, 1, newChapters[chapterInd])[0];
                                                    setJson(JSON.parse(JSON.stringify(newChapters)));
                                                }else{
                                                    //newChapters.unshift( newChapters.splice(chapterInd,1)[0]);
                                                    message.info("已经是最后一章了，无法下移")
                                                }
                                            
                                                
                                               
                                                
                                                
                                            }}
                                            /> </Tooltip>
                                           
                                        <Popconfirm placement="top" title={'确认删除章"' + chapter.name + '"吗？'} onConfirm={() => {
                                                const newChapters = [...json];
                                                newChapters.splice(chapterInd, 1);
                                                setJson(JSON.parse(JSON.stringify(newChapters)));
                                                
                                            }} okText="确认" cancelText="取消">
                                        <CloseCircleOutlined  style={{marginRight: 5, color: '#ff4d4f'}}  className= {myStyles.moduleBtn} />
                                        </Popconfirm> 
                                    </Col>
                                    
                                </Row> 
                                
    
                                {chapter.tasks.map((task, taskIndex) => (
                                    <DndDraggable
                                    key={task.id}
                                    draggableId={String(task.id)}
                                    index={taskIndex}
                                    > 
                                    {(provided, snapshot) => (
                                        <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                        )}
                                        > 
                                        <div className={myStyles.moduleWrapper} style={{textAlign: "left"}}> {/* 节点div */}
                                            <Row wrap={false}  gutter={[0, 4]} justify='start' align='middle' className={myStyles.module}>
                                                <Col flex='60px' style={{marginLeft:20,textAlign: "center"}} ><Tooltip title="拖拽排序"><MenuOutlined className= {myStyles.moduleBtn} /></Tooltip> {(chapterInd + 1) + "." + (taskIndex+1)} </Col>
                                                <Col flex="auto"  > <div style={{overflow:"hidden",minWidth:500}}> {" "} {json[chapterInd].tasks[taskIndex].name}</div></Col>
                                                
                                                <Col flex="200px" style={{textAlign:"right",marginRight:10}}>
                                                    <Button size="small" type="default" style={{marginRight:10,borderRadius:3, border:"1px solid #4f46e5",color:"#4f46e5"}} onClick={()=>{window.open("/oam_report_node_edit?node_id=" + task.id)}} >编辑</Button>
                                                    <Popconfirm placement="top" title={'确认删除节点"' + (chapterInd + 1) + "." + (taskIndex+1) + " "+  task.name + '"吗？'} onConfirm={() => {
                                                        const newMenuDirectory = [...json];
                                                        newMenuDirectory[chapterInd].tasks.splice(taskIndex, 1);
                                                        setJson(
                                                            newMenuDirectory.filter(group => group.tasks.length >= 0)
                                                        );
                                                        saveReport();
                                                    }} okText="确认" cancelText="取消">
                                                     
                                                            <CloseCircleOutlined  style={{marginRight: 5, color: '#ff4d4f'}} className= {myStyles.moduleBtn} />
                                                    </Popconfirm>  
                                                </Col>

                                            </Row>  
                                        
                                        </div>
                                    </div>
                                    )}
                                    </DndDraggable>
                                ))}
                                
                                {provided.placeholder}
                            </div>
                        )}
                    
                        </Droppable>
                    ))}
                    </DragDropContext>

                    <div style={{ textAlign:'right', marginBottom:20}}>
                    <Button onClick={handleAddChapterOk} className={myStyles.addChapterBtn} style={{width:"100%",height:42,borderRadius:0,marginRight:30}} type="default"> + 添加章</Button> 
                </div>

                </div>

              

                <ConfigProvider locale={zhCN}>
                    <Modal
                            title={<div
                            style={{
                            width: '100%',
                            cursor: 'move',
                            }}
                            onMouseOver={() => {
                            if (disabled) {
                                setDisabled(false)
                            }
                            }}
                            onMouseOut={() => {
                            setDisabled(true)
                            }}
                            onFocus={() => {}}
                            onBlur={() => {}}
                
                        >
                            选择节点
                        </div>
                        }
                        closable={false}
                        open={isAddNodeModalVisible}
                        onOk={handleAddNodeOk}
                        onCancel={handleAddNodeCancel}
                        bodyStyle={{overflow:"hidden"}}
                        destroyOnClose={true}
                        width={750}
                        modalRender={modal => (<div className={myStyles.createDiv}>
                            <Draggable
                            disabled={disabled}
                            bounds={bounds}
                            onStart={(event, uiData) => onStart(event, uiData)}
                            >
                            <div ref={draggleRef}>{modal}</div>
                            </Draggable> </div>
                        )}
                    >
                                         
                    <Input
                        onPressEnter={onSearchTaskBtn} 
                        placeholder="搜索节点名称/ID" 
                        style={{float:'left',borderRadius:20,width:300,marginBottom:10}} 
                        suffix={<SearchOutlined  style={{color:"#666666"}}/>}
                    />
                            <div style={{height:480}} className={idataCodingTableStyles.tableWrapper}>
                                <ConfigProvider locale={zhCN}>
                                    <Table
                                        dataSource={nodeListResult}
                                        columns={node_columns}
                                        rowKey={record => record.id}
                                        pagination={false}
                                        size="small"
                                        onChange={onNodeTableChange}
                                        rowSelection={{
                                            type: "checkbox",
                                            ...rowNodeSelection,
                                          }}
                                    />
                                </ConfigProvider>
                                </div>

                        <ConfigProvider locale={zhCN}>
                            <div style={{paddingTop:20,textAlign:"center"}} className={"css.pagination"} >
                                <Pagination
                                    defaultCurrent={1}
                                    total={nodeResultSum}
                                    defaultPageSize={10}
                                    hideOnSinglePage={true}
                                    current={nodePage.current}
                                    onChange={onNodePageChange}
                                    showTotal={total => `找到 ${total} 节点`}
                                    showSizeChanger={false}
                                />
                            </div>
                        </ConfigProvider>
                        
                    </Modal>
                </ConfigProvider>
            </div>
            </Content>
                
            
        </Layout>

    )

}

export default OAMReportEdit
